<template>
  <div class="pro">
    <Banner />
    <!-- <Prolink />  -->
    <div class="prolink">
      <div class="container">
        <el-tabs>
          <el-tab-pane>
            <div slot="label" class="program-menu">
              <div class="program-menu-pic">
                <img src="@/assets/img/pro/vms.svg" />
              </div>
              <h4>VMS</h4>
              <p>可视化管理系统</p>
            </div>
            <Vms />
          </el-tab-pane>
          <el-tab-pane>
            <div slot="label" class="program-menu">
              <div class="program-menu-pic">
                <img src="@/assets/img/pro/ctm.svg" />
              </div>
              <h4>CTM</h4>
              <p>临床试验管理系统</p>
            </div>
            <Ctm />
          </el-tab-pane>
          <el-tab-pane>
            <div slot="label" class="program-menu">
              <div class="program-menu-pic">
                <img src="@/assets/img/pro/sdc.svg" />
              </div>
              <h4>SDC</h4>
              <p>源数据采集系统</p>
            </div>
            <Sdc />
          </el-tab-pane>
          <el-tab-pane>
            <div slot="label" class="program-menu">
              <div class="program-menu-pic">
                <img src="@/assets/img/pro/edc.svg" />
              </div>
              <h4>EDC</h4>
              <p>电子数据采集系统</p>
            </div>
            <Edc />
          </el-tab-pane>
          <el-tab-pane>
            <div slot="label" class="program-menu">
              <div class="program-menu-pic">
                <img src="@/assets/img/pro/pvs.svg" />
              </div>
              <h4>PVS</h4>
              <p>药物警戒管理系统</p>
            </div>
            <Pvs />
          </el-tab-pane>
          <el-tab-pane>
            <div slot="label" class="program-menu">
              <div class="program-menu-pic">
                <img src="@/assets/img/pro/dcs.svg" />
              </div>
              <h4>DCS</h4>
              <p>数字化文档协作管理系统</p>
            </div>
            <Dcs />
          </el-tab-pane>
          <el-tab-pane>
            <div slot="label" class="program-menu">
              <div class="program-menu-pic">
                <img src="@/assets/img/pro/ccm.svg" />
              </div>
              <h4>CCM</h4>
              <p>临床任务协作管理系统</p>
            </div>
            <Ccm />
          </el-tab-pane>
          <el-tab-pane>
            <div slot="label" class="program-menu">
              <div class="program-menu-pic">
                <img src="@/assets/img/pro/mda.svg" />
              </div>
              <h4>MDA</h4>
              <p>移动数据采集系统</p>
            </div>
            <Mda />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "./pages/Banner";
// import Prolink from './pages/Prolink'
import Vms from "./pages/Vms";
import Ctm from "./pages/Ctm";
import Sdc from "./pages/Sdc";
import Edc from "./pages/Edc";
import Pvs from "./pages/Pvs";
import Dcs from "./pages/Dcs";
import Ccm from "./pages/Ccm";
import Mda from "./pages/Mda";
export default {
  data() {
    return {};
  },
  components: {
    Banner,
    Vms,
    Ctm,
    Sdc,
    Edc,
    Pvs,
    Dcs,
    Ccm,
    Mda,
  },
};
</script>
<style>
.pro {
  text-align: center;
}
.program-menu-pic {
  background: linear-gradient(#f1f3f8, #dededd);
  border-radius: 15px;
  width: 50px;
  height: 50px;
  margin: 0 auto;
  display: flex;
  padding: 20px;
  justify-content: center;
}
.mr-30 {
  margin-right: 30px;
}
.about-text {
  text-indent: 2em;
}
.prolink .el-tabs__nav {
  display: flex;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
}
.prolink .pro-el-menu {
  display: flex;
}
.pro-el-menu a {
  display: block;
  text-align: center;
  padding: 0;
  text-decoration: none;
}
.program-menu h4 {
  font-weight: normal;
  margin: 0;
  font-size: 20px;
}
.program-menu p {
  margin: 0px;
  line-height: 25px;
}
.prolink .el-tabs__item,
.program-menu {
  height: 160px;
  margin: 20px 0;
  flex: 1 0 0;
}
.prolink .el-menu--horizontal > .program-menu {
  height: 160px;
  line-height: 35px;
  flex: 1 0 0;
}
img {
  max-width: 100%;
  height: auto;
}
</style>
